import React from "react";
import {
  AssignedUsersIcon,
  ColumnContext,
  DuedateTag,
  KanbanContext,
  PriorityTag,
  ProjectDropdown,
  StateCircle,
  TicketManager,
  useTicketData,
} from "../../..";
import { SourceSelectPopupIcon } from "../../../source/components/SourceSelectPopupIcon";
import { TicketLink } from "../TicketLink";

type Props = {
  /**
   * Custom reload function when any data changes, will be used if the component is rendered outside of the kanban board
   */
  reload?: () => void;
  managers?: {
    filterManager?: TicketManager;
  };
};

export const TicketTagBar = (props: Props) => {
  const kanbanManager = React.useContext(KanbanContext);
  const columnId = React.useContext(ColumnContext);
  const ticketData = useTicketData();

  return (
    <>
      {ticketData.duedate && <DuedateTag asIcon />}

      <ProjectDropdown
        onSave={(newId) => {
          if (!kanbanManager) return props.reload?.();
          kanbanManager.reload(columnId);
          kanbanManager.reload(newId);
        }}
      />
      <StateCircle
        onSave={(oldState, newState) => {
          if (kanbanManager) {
            kanbanManager.reload(oldState.id);
            kanbanManager.reload(newState.id);
          } else props.reload?.();
        }}
      />

      <PriorityTag
        onSave={() => kanbanManager?.reload(columnId) ?? props.reload?.()}
        asIcon
      />

      <AssignedUsersIcon
        onSave={() => kanbanManager?.reload() ?? props.reload?.()}
      />

      <SourceSelectPopupIcon
        onSave={() => kanbanManager?.reload() ?? props.reload?.()}
      />

      <TicketLink />
    </>
  );
};
